import { styled } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";

const StyledAnchorLink = styled("a")(({ theme }) => ({
  alignItems: "center",
  background: theme.palette.grey[200],
  borderRadius: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: 0,
  justifyContent: "center",
  flex: 1,
  minWidth: "45%",
  maxWidth: "50%",
  boxShadow: `0 0 0 1px ${theme.palette.grey[300]}`,
  textDecoration: "none",
  backgroundSize: "cover",
  aspectRatio: "3/1",

  [theme.breakpoints.up("md")]: {
    aspectRatio: "1.618/1",
    minWidth: "30%",
    maxWidth: "33%",
    justifyContent: "flex-end",
  },

  "& .category-title": {
    ...theme.typography.subtitle1,
    margin: 0,
    textAlign: "center",
    background: "rgba(255,255,255,0.7)",
    backdropFilter: "blur(4px)",
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(1),

    [theme.breakpoints.up("md")]: {
      width: "100%",
      background: "rgba(255,255,255,0.9)",
      padding: theme.spacing(1),
      borderRadius: theme.spacing(2),
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
  },

  "&:hover": {
    filter: "brightness(0.9)",
  },
}));

const StyledRouterLink = styled(Link)(({ theme }) => ({
  alignItems: "center",
  background: theme.palette.grey[200],
  borderRadius: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: 0,
  justifyContent: "center",
  flex: 1,
  minWidth: "45%",
  maxWidth: "50%",
  boxShadow: `0 0 0 1px ${theme.palette.grey[300]}`,
  textDecoration: "none",
  backgroundSize: "cover",
  aspectRatio: "3/1",

  [theme.breakpoints.up("md")]: {
    aspectRatio: "1.618/1",
    minWidth: "30%",
    maxWidth: "33%",
    justifyContent: "flex-end",
  },

  "& .category-title": {
    ...theme.typography.subtitle1,
    margin: 0,
    textAlign: "center",
    background: "rgba(255,255,255,0.7)",
    backdropFilter: "blur(4px)",
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(1),

    [theme.breakpoints.up("md")]: {
      width: "100%",
      background: "rgba(255,255,255,0.9)",
      padding: theme.spacing(1),
      borderRadius: theme.spacing(2),
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
  },

  "&:hover": {
    filter: "brightness(0.9)",
  },
}));

export default function Category({ category, onClick }) {
  const location = useLocation();

  const { imageUrl, name, categoryId } = category;

  if (location?.pathname === "/shops") {
    return (
      <StyledAnchorLink
        style={{ backgroundImage: `url(${imageUrl})` }}
        href={`/shops?g=${categoryId}`}
        onClick={onClick}
      >
        <span className="category-title">{name}</span>
      </StyledAnchorLink>
    );
  }

  return (
    <StyledRouterLink
      style={{ backgroundImage: `url(${imageUrl})` }}
      to={`/shops?g=${categoryId}`}
      onClick={onClick}
    >
      <span className="category-title">{name}</span>
    </StyledRouterLink>
  );
}

Category.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    categoryId: PropTypes.number.isRequired,
    imageUrl: PropTypes.string,
  }),
  onClick: PropTypes.func,
};
